import {
  flow,
  getOr,
  has,
  includes,
  keyBy,
  map,
  reduce,
  reject
} from 'lodash/fp';
import { AddressFieldsWithPermissionMap } from '../GuestAddressFieldsWithPermission';

export const ASSOC_ID_FIELD = 'AssociationVisit.association_id';
export const ASSOC_LINK_FIELD = 'AssociationLink.associationLink';
export const ASSOC_LINK_ID_FIELD = 'AssociationVisit.associationLink_id';
export const DOMAIN_FIELD = 'Domain.domain';
export const DOMAIN_ID_FIELD = 'AssociationVisit.domain_id';
export const GUEST_ID_FIELD = 'AssociationVisit.guest_id';
export const VISIT_ID_FIELD = 'AssociationVisit.visit_id';
export const LOCATION_FIELD = 'AssociationVisit.location';
export const FIRST_NAME_FIELD = 'AssociationVisit.firstname';
export const MIDDLE_NAME_FIELD = 'AssociationVisit.middlename';
export const LAST_NAME_FIELD = 'AssociationVisit.lastname';
export const STREET_ADDRESS_FIELD = 'AssociationVisit.street_address';
export const APARTMENT_FIELD = 'AssociationVisit.apartment';
export const CITY_FIELD = 'AssociationVisit.city';
export const STATE_FIELD = 'AssociationVisit.state';
export const ZIPCODE_FIELD = 'AssociationVisit.zipcode';
export const COUNTY_FIELD = 'AssociationVisit.county';
export const VISIT_ON_FIELD = 'AssociationVisit.visit_on';

export const FieldsSettings = [
  {
    name: ASSOC_LINK_FIELD,
    label: 'Association Link',
    type: 'varchat',
    fieldType: 'string',
    readOnly: false,
    status: 1,
    group: 'Assoc Visit'
  },
  {
    name: ASSOC_LINK_ID_FIELD,
    label: 'Association Link ID',
    type: 'integer',
    fieldType: 'association_link_multi_select',
    readOnly: false,
    status: 1,
    group: 'Assoc Visit'
  },
  {
    name: DOMAIN_FIELD,
    label: 'Domain',
    type: 'varchar',
    fieldType: 'string',
    readOnly: false,
    status: 1,
    group: 'Assoc Visit'
  },
  {
    name: DOMAIN_ID_FIELD,
    label: 'Domain ID',
    type: 'integer',
    fieldType: 'associated_domain_multi_select',
    readOnly: false,
    status: 1,
    group: 'Assoc Visit'
  },
  {
    name: GUEST_ID_FIELD,
    label: 'Guest ID',
    type: 'integer',
    fieldType: 'number',
    readOnly: false,
    status: 1,
    group: 'Assoc Visit'
  },
  {
    name: LOCATION_FIELD,
    label: 'Location',
    type: 'varchar',
    fieldType: 'location_select',
    readOnly: false,
    status: 1,
    group: 'Assoc Visit'
  },
  {
    name: FIRST_NAME_FIELD,
    label: 'First Name',
    type: 'varchar',
    fieldType: 'string',
    readOnly: false,
    status: 1,
    group: 'Assoc Visit'
  },
  {
    name: MIDDLE_NAME_FIELD,
    label: 'Middle Name',
    type: 'varchar',
    fieldType: 'string',
    readOnly: false,
    status: 1,
    group: 'Assoc Visit'
  },
  {
    name: LAST_NAME_FIELD,
    label: 'Last Name',
    type: 'varchar',
    fieldType: 'string',
    readOnly: false,
    status: 1,
    group: 'Assoc Visit'
  },
  {
    name: STREET_ADDRESS_FIELD,
    label: 'Street Address',
    type: 'varchar',
    fieldType: 'string',
    readOnly: false,
    status: 1,
    group: 'Assoc Visit'
  },
  {
    name: APARTMENT_FIELD,
    label: 'Apartment',
    type: 'varchar',
    fieldType: 'string',
    readOnly: false,
    status: 1,
    group: 'Assoc Visit'
  },
  {
    name: CITY_FIELD,
    label: 'City',
    type: 'varchar',
    fieldType: 'string',
    readOnly: false,
    status: 1,
    group: 'Assoc Visit'
  },
  {
    name: STATE_FIELD,
    label: 'State',
    type: 'varchar',
    fieldType: 'string',
    readOnly: false,
    status: 1,
    group: 'Assoc Visit'
  },
  {
    name: ZIPCODE_FIELD,
    label: 'Zip Code',
    type: 'varchar',
    fieldType: 'string',
    readOnly: false,
    status: 1,
    group: 'Assoc Visit'
  },
  {
    name: COUNTY_FIELD,
    label: 'County',
    type: 'varchar',
    fieldType: 'string',
    readOnly: false,
    status: 1,
    group: 'Assoc Visit'
  },
  {
    name: VISIT_ON_FIELD,
    label: 'Visit On',
    type: 'datetime',
    fieldType: 'date_range',
    readOnly: false,
    status: 1,
    group: 'Assoc Visit'
  }
];

export const UnsupportedFilterFields = [
  GUEST_ID_FIELD,
  LOCATION_FIELD,
  ASSOC_LINK_FIELD,
  DOMAIN_FIELD
];

export const FilterCustomLabel = {
  [DOMAIN_ID_FIELD]: 'Domain',
  [ASSOC_LINK_ID_FIELD]: 'Association Link'
};

export const getFilterFieldsSettings = hasViewAddressPermission =>
  reduce((fields, each) => {
    const { name } = each;
    if (includes(name, UnsupportedFilterFields)) return fields;

    const [, field] = name.split('.');
    if (!hasViewAddressPermission && has(field, AddressFieldsWithPermissionMap))
      return fields;

    const label = getOr(each.label, name, FilterCustomLabel);
    return { ...fields, [name]: { ...each, label } };
  }, {})(FieldsSettings);

export const SettingsByField = keyBy('name', FieldsSettings);

export const getColumnOptions = hasViewAddressPermission =>
  flow(
    reject(({ name }) => {
      const [, field] = name.split('.');
      return (
        name === VISIT_ON_FIELD ||
        (!hasViewAddressPermission &&
          has(field, AddressFieldsWithPermissionMap))
      );
    }),
    map(({ name: value, label, group }) => ({ label, value, group }))
  )(FieldsSettings);
